export default __webpack_public_path__ + "static/media/GothamSSm-Medium.ee79bd3a.woff";